import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { FeatureFlag } from '@sonar-software/sonar-core';
import { JiraIssuesPopover } from './JiraIssuesPopover';
import { jiraSummarySelectors } from '../../../settings/jira/@arch/selectors';
import React from 'react';
import { Popover, Radio } from 'antd';
import { useCurrentUser, useFeatureFlag, useSonarSelector } from '@hooks';
export const JiraIssuesButton = ({ initiativeId }) => {
    const { isReadOnly } = useCurrentUser();
    const jiraActive = useFeatureFlag(FeatureFlag.JiraIntegration);
    const jiraSummary = useSonarSelector(jiraSummarySelectors.data);
    if (isReadOnly || !jiraActive || !(jiraSummary === null || jiraSummary === void 0 ? void 0 : jiraSummary.connected)) {
        return null;
    }
    return (React.createElement(Popover, { classNames: { root: 'jira-issue-popover' }, content: React.createElement(JiraIssuesPopover, { initiativeId: initiativeId }), destroyOnHidden: true, placement: 'bottom', trigger: 'click' },
        React.createElement(Radio.Button, { id: 'jira-issues-button', value: 'issues' }, COPY_SPECIFIC.JIRA_ISSUES)));
};
